import { EntityApiClient } from './entity-api-client';
import { Injector, Injectable } from '@angular/core';


@Injectable({providedIn: 'root'})
export class EntityApiClientFactory {
    constructor(private injector: Injector) {

    }

    create<TModel, TQueryModel>(entityName: string) {
        return new EntityApiClient<TModel, TQueryModel>(this.injector, entityName);
    }

}